import { Injectable } from '@angular/core';

/** Languages the questions exist in, with their own names (shown as-is in every interface language). */
export const QUESTION_LANGUAGES = [
  { code: 'am', label: 'Հայերեն' },
  { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
  { code: 'ar', label: 'العربية' },
  { code: 'fa', label: 'فارسی' },
] as const;

const STORAGE_KEY = 'drivon.quiz.questionLanguage';

/**
 * Language of the test questions, chosen on the test list independently of the interface
 * language (e.g. an English interface with Arabic questions). Until a visitor picks one, the
 * questions follow the interface language.
 */
@Injectable({ providedIn: 'root' })
export class QuestionLanguageService {
  /** Kept in memory as well, for browsers that block storage. */
  private chosen: string | null = null;

  get(siteLanguage: string): string {
    try {
      return localStorage.getItem(STORAGE_KEY) || this.chosen || siteLanguage;
    } catch {
      return this.chosen || siteLanguage;
    }
  }

  set(language: string) {
    this.chosen = language;
    try {
      localStorage.setItem(STORAGE_KEY, language);
    } catch {
      // Storage blocked - the choice lasts until the page is reloaded.
    }
  }

  /** Languages the questions are in: roadpolice.am publishes the bank in all five. */
  available() {
    return QUESTION_LANGUAGES;
  }
}
